import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = {
  class: "modal-dialog modal-lg modal-dialog-scrollable",
  style: {"min-height":"600px"}
}
const _hoisted_4 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = { class: "input-group-append" }
const _hoisted_11 = {
  class: "dropdown-menu dropdown-menu-right",
  style: {"background-color":"#F5F5F5","width":"70%"}
}
const _hoisted_12 = { class: "px-2 py-1" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "px-3 py-1" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { style: {"max-height":"200px","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_17 = {
  key: 0,
  class: "dropdown-header"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = { class: "modal-footer" }
const _hoisted_23 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  class: "navbar navbar-light navbar-expand-md bg-light",
  role: "navigation"
}
const _hoisted_27 = {
  class: "btn-group mr-auto",
  role: "group"
}
const _hoisted_28 = { class: "navbar-text" }
const _hoisted_29 = {
  class: "form-inline my-2 my-lg-0 ml-2",
  role: "search"
}
const _hoisted_30 = { class: "input-group input-group-sm" }
const _hoisted_31 = { class: "table table-hover" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "text-muted" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CriterionSelectorDialog = _resolveComponent("CriterionSelectorDialog")!
  const _component_AttributeEditorDialog = _resolveComponent("AttributeEditorDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _component_GoalNavigation = _resolveComponent("GoalNavigation")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_CriterionSelectorDialog, {
      viewModel: _ctx.criterionSelectorDialog,
      onConfirmSelection: _ctx.changeCriterion
    }, null, 8 /* PROPS */, ["viewModel", "onConfirmSelection"]),
    (_ctx.criterionEditorOpened === true)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.editedCriterion)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("h5", _hoisted_6, "Criterion: " + _toDisplayString(_ctx.editedCriterion.Name), 1 /* TEXT */),
                      _createElementVNode("button", {
                        type: "button",
                        class: "close",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeCriterionEditor && _ctx.closeCriterionEditor(...args)))
                      }, "×")
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", null, "Linked attribute:", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_9, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            readonly: "",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editedCriterion.attributeNameOrNone) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, _ctx.editedCriterion.attributeNameOrNone]
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _cache[14] || (_cache[14] = _createElementVNode("button", {
                              class: "btn btn-outline-secondary dropdown-toggle",
                              type: "button",
                              "data-toggle": "dropdown"
                            }, "Choose", -1 /* CACHED */)),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("button", {
                                  class: "btn btn-secondary btn-sm mr-1",
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAttributeCreator()))
                                }, "Create new attribute"),
                                _createElementVNode("button", {
                                  class: "btn btn-secondary btn-sm",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editedCriterion.unlink())),
                                  disabled: !_ctx.editedCriterion.AttributeId
                                }, "Unlink attribute", 8 /* PROPS */, _hoisted_13)
                              ]),
                              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                              _createElementVNode("form", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.SearchAttributePhrase) = $event)),
                                    type: "text",
                                    class: "form-control",
                                    placeholder: "search"
                                  }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, _ctx.SearchAttributePhrase]
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AttributesSections, (s) => {
                                  return (_openBlock(), _createElementBlock("div", null, [
                                    (s.Section)
                                      ? (_openBlock(), _createElementBlock("h6", _hoisted_17, _toDisplayString(s.Section), 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.Attributes, (attr) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: attr.Id,
                                        onClick: ($event: any) => (_ctx.editedCriterion.link(attr.Id)),
                                        class: "dropdown-item"
                                      }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_18))
                                    }), 128 /* KEYED_FRAGMENT */)),
                                    _cache[12] || (_cache[12] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */))
                                  ]))
                                }), 256 /* UNKEYED_FRAGMENT */))
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("label", null, [
                          (_ctx.editedCriterion.defaultMax == null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "*"))
                            : _createCommentVNode("v-if", true),
                          _cache[16] || (_cache[16] = _createTextVNode("Normalization cap:", -1 /* CACHED */))
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editedCriterion.MaxValue) = $event)),
                          placeholder: _ctx.editedCriterion.defaultMax
                        }, null, 8 /* PROPS */, _hoisted_21), [
                          [_vModelText, _ctx.editedCriterion.MaxValue]
                        ]),
                        _cache[17] || (_cache[17] = _createElementVNode("p", { class: "form-text text-muted" }, " Criteria must have a maximum value, beyond which no extra value is given in calculating normalized score. Scores are calculated as a ratio of this Normalization cap. It is usually defined as the highest value in a scale. ", -1 /* CACHED */))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("button", {
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleUpdateCriterionMeasurementCommand && _ctx.handleUpdateCriterionMeasurementCommand(...args))),
                        type: "button",
                        class: "btn btn-primary"
                      }, "Confirm"),
                      _createElementVNode("button", {
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeCriterionEditor && _ctx.closeCriterionEditor(...args))),
                        type: "button",
                        class: "btn btn-outline-secondary"
                      }, "Cancel")
                    ])
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_AttributeEditorDialog, {
      viewModel: _ctx.attributeEditorDialog,
      onNumericAttributeCreated: _ctx.numericAttributeCreated,
      onNumericAttributeUpdated: _ctx.numericAttributeUpdated
    }, null, 8 /* PROPS */, ["viewModel", "onNumericAttributeCreated", "onNumericAttributeUpdated"]),
    _createVNode(_component_PortfolioOrDecisionNavigation, {
      workspaceId: _ctx.workspaceId,
      projectId: _ctx.projectId
    }, null, 8 /* PROPS */, ["workspaceId", "projectId"]),
    _createElementVNode("div", _hoisted_23, [
      (!_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_24, [...(_cache[18] || (_cache[18] = [
            _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
            _createTextVNode(" Loading... ", -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.Initialized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
            _cache[27] || (_cache[27] = _createElementVNode("a", {
              class: "btn btn-outline-secondary float-right",
              href: "https://www.transparentchoice.com/user-guide/build-criteria",
              title: "User guide: Build criteria",
              target: "_blank"
            }, [
              _createElementVNode("i", {
                class: "fa fa-info",
                "aria-hidden": "true"
              })
            ], -1 /* CACHED */)),
            _createElementVNode("h3", null, "Goal: " + _toDisplayString(_ctx.rm.GoalName), 1 /* TEXT */),
            _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createVNode(_component_GoalNavigation, {
              WorkspaceId: _ctx.workspaceId,
              ProjectId: _ctx.projectId,
              EvalModelId: _ctx.evalModelId,
              ActivePage: 'measurement',
              ScoringEnabled: _ctx.rm.ScoringEnabled
            }, null, 8 /* PROPS */, ["WorkspaceId", "ProjectId", "EvalModelId", "ScoringEnabled"]),
            _createElementVNode("nav", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  title: "Expand all",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.expandAll && _ctx.expandAll(...args)))
                }, [...(_cache[19] || (_cache[19] = [
                  _createElementVNode("i", {
                    class: "fa fa-expand",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */)
                ]))]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-outline-secondary",
                  title: "Collapse all",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.collapseAll && _ctx.collapseAll(...args)))
                }, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("i", {
                    class: "fa fa-compress",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */)
                ]))])
              ]),
              _createElementVNode("span", _hoisted_28, [
                _cache[21] || (_cache[21] = _createTextVNode("Filter by: ", -1 /* CACHED */)),
                _createElementVNode("a", {
                  class: "text-primary",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.showCriterionSelector && _ctx.showCriterionSelector(...args)))
                }, _toDisplayString(_ctx.FilterByCriterion?.Name ?? "All criteria"), 1 /* TEXT */)
              ]),
              _createElementVNode("form", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.SearchPhrase) = $event)),
                    class: "form-control form-control-sm",
                    type: "search",
                    placeholder: "Search"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.SearchPhrase]
                  ]),
                  _cache[22] || (_cache[22] = _createElementVNode("span", { class: "input-group-append" }, [
                    _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", {
                        class: "fa-solid fa-magnifying-glass",
                        "aria-hidden": "true"
                      })
                    ])
                  ], -1 /* CACHED */))
                ])
              ])
            ]),
            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _createElementVNode("table", _hoisted_31, [
              _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { style: {"width":"60px"} }),
                  _createElementVNode("th", { style: {"width":"50%"} }, "Criterion"),
                  _createElementVNode("th", null, "Linked attribute")
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.BottomCriteriaView, (c) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: c.Id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn", {'btn-danger': c.IsValid === false, 'btn-success': c.IsValid === true}]),
                        onClick: ($event: any) => (_ctx.showCriterionEditor(c.Id)),
                        type: "button"
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(["fa", {'fa-unlink': c.Attribute == null, 'fa-link': c.Attribute != null}]),
                          "aria-hidden": "true"
                        }, null, 2 /* CLASS */)
                      ], 10 /* CLASS, PROPS */, _hoisted_32)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("h5", {
                        class: "pointer",
                        onClick: ($event: any) => (c.Expanded = !c.Expanded)
                      }, [
                        _createElementVNode("span", null, _toDisplayString(c.Criterion.Name), 1 /* TEXT */),
                        _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("small", _hoisted_34, _toDisplayString(c.Criterion.Path), 1 /* TEXT */),
                        _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                        _createElementVNode("small", null, "Normalization cap: " + _toDisplayString(c.Criterion.MaxValue?.toString() ?? 'Not set'), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_33),
                      (c.Expanded)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                            _createElementVNode("p", null, _toDisplayString(c.Criterion.Description), 1 /* TEXT */)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("td", null, [
                      (c.Attribute != null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("h5", {
                              class: "pointer",
                              onClick: ($event: any) => (c.Expanded = !c.Expanded)
                            }, _toDisplayString(c.Attribute.Name), 9 /* TEXT, PROPS */, _hoisted_37),
                            (c.Expanded)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                  _createElementVNode("p", null, _toDisplayString(c.Attribute.Description), 1 /* TEXT */),
                                  (c.Attribute.IsList === true)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.Attribute.DefinedValues, (dv) => {
                                          return (_openBlock(), _createElementBlock("p", {
                                            key: dv.Name
                                          }, [
                                            _createElementVNode("strong", null, _toDisplayString(dv.Value) + " - " + _toDisplayString(dv.Name), 1 /* TEXT */),
                                            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                            _createElementVNode("span", null, _toDisplayString(dv.Description), 1 /* TEXT */)
                                          ]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ]))
                                    : _createCommentVNode("v-if", true),
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-primary",
                                    onClick: ($event: any) => (_ctx.showAttributeEditor(c.Attribute))
                                  }, "Edit attribute", 8 /* PROPS */, _hoisted_40)
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]),
            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "alert alert-danger" }, [
              _createElementVNode("p", null, " NEGATIVE numbers will be rounded to zero in any calculations. Remember, you could use calculated attributes to transform your values so they are all positive. ")
            ], -1 /* CACHED */))
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}